var slot = 'fx_e395032e_1n50dn60';

export { slot };
//# sourceMappingURL=slot.vanilla.mjs.map
